function pad2(n) {
  return String(n).padStart(2, "0");
}

export function todayIsoDate(now = new Date()) {
  return `${now.getFullYear()}-${pad2(now.getMonth() + 1)}-${pad2(now.getDate())}`;
}

export function toIsoDate(value) {
  if (!value) return "";
  const match = String(value).match(/^(\d{4}-\d{2}-\d{2})/);
  if (match) return match[1];
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "";
  return `${parsed.getUTCFullYear()}-${pad2(parsed.getUTCMonth() + 1)}-${pad2(parsed.getUTCDate())}`;
}

/** Calendar month/year from a date-only or ISO value. */
export function calendarMonthYearFromDate(value, fallback = new Date()) {
  const iso = toIsoDate(value);
  if (iso) {
    const year = Number(iso.slice(0, 4));
    const month = Number(iso.slice(5, 7));
    if (Number.isFinite(year) && Number.isFinite(month) && month >= 1 && month <= 12) {
      return { year, month };
    }
  }
  return {
    year: fallback.getFullYear(),
    month: fallback.getMonth() + 1,
  };
}

export function daysInCalendarMonth(year, month) {
  return new Date(Number(year), Number(month), 0).getDate();
}

function emptyPunchDay({ iso, employee, future }) {
  return {
    id: `empty-${iso}`,
    employeeId: employee?.id ?? null,
    employeeCode: employee?.code || employee?.employeeCode || "",
    employeeName: employee?.name || employee?.fullName || "",
    date: iso,
    checkInTime: null,
    checkOutTime: null,
    breakOutTime: null,
    breakInTime: null,
    totalWorkingHours: 0,
    overtimeHours: 0,
    overtimeDisposition: null,
    lateMinutes: 0,
    earlyMinutes: 0,
    actualPunchCount: null,
    expectedPunchCount: null,
    incomplete: false,
    location: null,
    status: null,
    source: null,
    empty: true,
    future,
    permits: [],
    leaves: [],
  };
}

/**
 * Expand punch rows so every calendar day from 1..last day of the month appears.
 * Existing records keep their data; missing days become empty placeholders.
 */
export function fillMonthPunchDays(
  days,
  year,
  month,
  employee = null,
  today = todayIsoDate(),
) {
  const byDate = new Map();
  for (const row of days || []) {
    const iso = toIsoDate(row.date);
    if (!iso) continue;
    byDate.set(iso, {
      ...row,
      date: iso,
      empty: row.empty === true,
    });
  }

  const y = Number(year);
  const m = Number(month);
  const lastDay = daysInCalendarMonth(y, m);
  if (!Number.isFinite(y) || !Number.isFinite(m) || lastDay < 1) return [];

  const monthPrefix = `${y}-${pad2(m)}`;
  const rows = [];
  for (let day = 1; day <= lastDay; day += 1) {
    const iso = `${monthPrefix}-${pad2(day)}`;
    const future = iso > today;
    const rec = byDate.get(iso);
    if (rec) {
      rows.push({ ...rec, future });
      continue;
    }
    rows.push(emptyPunchDay({ iso, employee, future }));
  }
  return rows;
}
